import React, { lazy } from 'react';
import {
  BASE_URL,
  ADMIN_URL,
  NOT_FOUND_URL,
  PRICE_URL,
  FAQ_INSTALL_URL,
  ADMIN_USERS_URL,
  //ADMIN_USER_BILLS_URL,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL,
  RESET_PASS_REJECT_URL,
  RESET_PASS_CONFIRM_URL,
  ADMIN_USER_SETTINGS_URL,
  ADMIN_USER_PASSWORD_URL,
  ADMIN_MANAGEMENT_SETTINGS_URL,
  ACTIVATED_SUCCESS_URL,
  KEYMAKER_URL,
  GET_PLUGIN_URL,
} from './routes.constants';

import FooterProvider from '@app/providers/footer';

//const Cart = lazy(() => import('@pages/cart'));
const HomePage = lazy(() => import('@pages/home'));
//const Career = lazy(() => import('@pages/career'));
//const LoginPage = lazy(() => import('@pages/login'));
//const AboutUs = lazy(() => import('@pages/about_us'));
const Price = lazy(() => import('@pages/price'));
const Faq = lazy(() => import('@pages/faq'));
const Users = lazy(() => import('@pages/admin/users'));
/*const Contacts = lazy(() => import('@pages/contacts'));
const Checkout = lazy(() => import('@pages/checkout'));
const LicensePage = lazy(() => import('@pages/licenses'));
const ProductsPage = lazy(() => import('@pages/products'));
const ProductsItem = lazy(() => import('@pages/products_item'));*/
//const MyBills = lazy(() => import('@pages/admin/my_bills'));
/*const Projects = lazy(() => import('@pages/admin/projects'));
const ProductsManagement = lazy(() => import('@pages/admin/products'));
const ProductEdit = lazy(() => import('@pages/admin/product_edit'));
const PromotedManagement = lazy(() => import('@pages/admin/promoted'));
const ReturnPolicy = lazy(() => import('@pages/return_policy'));*/
const CookiePolicy = lazy(() => import('@pages/cookie_policy'));
const PrivacyPolicy = lazy(() => import('@pages/privacy_policy'));
const ResetPassPage = lazy(() => import('@pages/password/reset'));
const AdminSettings = lazy(() => import('@pages/admin/settings'));
//const MyPurchases = lazy(() => import('@pages/admin/my_purchases'));
/*const TermsConditions = lazy(() => import('@pages/terms_conditions'));
const CheckoutProject = lazy(() => import('@pages/checkout_project'));
const ProjectsUser = lazy(() => import('@pages/admin/projects_user'));
const PaymentsStatus = lazy(() => import('@pages/payments_status'));
const PaymentProjectStatus = lazy(() => import('@pages/pay_project_status'));
const CreateProject = lazy(() => import('@pages/admin/create_project'));
const VacancyThemeMaker = lazy(() => import('@pages/vacancies/theme_maker'));
const VacancyIllustrator = lazy(() => import('@pages/vacancies/illustrator'));
const VacancySoftTester = lazy(() => import('@pages/vacancies/software_tester'));
const VacancyProjectManager = lazy(() => import('@pages/vacancies/project_manager'));*/
const PersonalSettings = lazy(() => import('@pages/admin/personal_settings'));
const PersonalPassword = lazy(() => import('@pages/admin/personal_password'));
const GetPlugin  = lazy(() => import('@pages/plugin'));
//const ArchiveProjects = lazy(() => import('@pages/admin/projects_archive'));
const EmailActivated = lazy(() => import('@pages/email_activated'));
/*const JobApplication = lazy(() => import('@pages/job_application'));
const TarotTalesPrivacyPolicy = lazy(() => import('@pages/tarottales/privacy_policy'));
const TarotTalesTermsAndConditions = lazy(() => import('@pages/tarottales/terms_conditions'));*/
const KeyMaker = lazy(() => import('@pages/key-maker'));

const NotFoundPage = lazy(() => import('@pages/404'));

export const STATIC_ROUTES = [
  {
    path: BASE_URL,
    element: (
      <FooterProvider>
        <HomePage />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: KEYMAKER_URL,
    element: <KeyMaker />,
    sitemapIndex: true,
    exact: true,
  },
  {
    path: PRICE_URL,
    element: (
      <FooterProvider>
        <Price />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: FAQ_INSTALL_URL,
    element: (
      <FooterProvider>
        <Faq />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  /*{
    path: BROWSE_URL,
    element: (
      <FooterProvider>
        <ProductsPage />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  /*{
    path: BROWSE_ITEM_URL,
    element: (
      <FooterProvider>
        <ProductsItem />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: LICENSES_URL,
    element: (
      <FooterProvider>
        <LicensePage />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ABOUT_US_URL,
    element: (
      <FooterProvider>
        <AboutUs />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  /*{
    path: CONTACTS_URL,
    element: (
      <FooterProvider>
        <Contacts />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  /*{
    path: CAREER_URL,
    element: (
      <FooterProvider>
        <Career />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: VACANCY_THEME_MAKER_URL,
    element: (
      <FooterProvider>
        <VacancyThemeMaker />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: VACANCY_ILLUSTRATOR_URL,
    element: (
      <FooterProvider>
        <VacancyIllustrator />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: VACANCY_SOFTWARE_TESTER_URL,
    element: (
      <FooterProvider>
        <VacancySoftTester />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: VACANCY_PROJECT_MANAGER_URL,
    element: (
      <FooterProvider>
        <VacancyProjectManager />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: JOB_APPLICATION_URL,
    element: (
      <FooterProvider>
        <JobApplication />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: JOB_APPLICATIONS_OLD_URL,
    element: (
      <FooterProvider>
        <JobApplication />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  {
    path: PRIVACY_POLICY_URL,
    element: (
      <FooterProvider>
        <PrivacyPolicy />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  /*{
    path: TERMS_CONDITIONS_URL,
    element: (
      <FooterProvider>
        <TermsConditions />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: RETURN_POLICY_URL,
    element: (
      <FooterProvider>
        <ReturnPolicy />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  {
    path: COOKIE_POLICY_URL,
    element: (
      <FooterProvider>
        <CookiePolicy />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  /*{
    path: ADMIN_PROJECT_CREATE_URL,
    element: <LoginPage />,
    sitemapIndex: true,
    exact: true,
  },*/
  {
    path: NOT_FOUND_URL,
    element: (
      <FooterProvider>
        <NotFoundPage />
      </FooterProvider>
    ),
    sitemapIndex: true,
  },
  {
    path: RESET_PASS_CONFIRM_URL,
    element: <ResetPassPage />,
    sitemapIndex: true,
  },
  {
    path: RESET_PASS_REJECT_URL,
    element: <ResetPassPage />, // RejectPassPage
    sitemapIndex: true,
  },
  {
    path: ACTIVATED_SUCCESS_URL,
    element: <EmailActivated />,
    sitemapIndex: true,
  },
  {
    path: GET_PLUGIN_URL,
    element: (
      <FooterProvider>
        <GetPlugin />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
];

export const AUTH_ROUTES = [
  {
    path: ADMIN_URL,
    element: <></>,
    sitemapIndex: true,
    internalsRouts: [
      /*{
        path: ADMIN_LOGIN_URL,
        element: <LoginPage />,
        sitemapIndex: true,
      },*/
      {
        path: ADMIN_URL,
        element: <NotFoundPage />,
        sitemapIndex: true,
      },
      {
        path: NOT_FOUND_URL,
        element: <NotFoundPage />,
        sitemapIndex: true,
      },
    ],
  },
];


// admin/ for all users
export const ADMIN_ROUTES = [
  /*{
    path: CART_URL,
    element: (
      <FooterProvider>
        <Cart />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },

  {
    path: CHECKOUT_URL,
    element: (
      <FooterProvider>
        <Checkout />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  /*{
    path: CHECKOUT_PROJECT_URL,
    element: (
      <FooterProvider>
        <CheckoutProject />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  /*{
    path: PAYMENT_STATUS_URL,
    element: (
      <FooterProvider>
        <PaymentsStatus />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  /*{
    path: PAYMENT_PROJECT_STATUS_URL,
    element: (
      <FooterProvider>
        <PaymentProjectStatus />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },*/
  {
    path: ADMIN_USER_SETTINGS_URL,
    element: (
      <FooterProvider>
        <PersonalSettings />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ADMIN_USER_PASSWORD_URL,
    element: (
      <FooterProvider>
        <PersonalPassword />
      </FooterProvider>
    ),
    sitemapIndex: true,
    exact: true,
  },
  /*{
    path: ADMIN_PURCHASES_URL,
    element: (
      <FooterProvider>
        <MyPurchases />
      </FooterProvider>),
    sitemapIndex: true,
    exact: true,
  },*/
  /*{
    path: ADMIN_USER_BILLS_URL,
    element: (
      <FooterProvider>
        <MyBills />
      </FooterProvider>),
    sitemapIndex: true,
    exact: true,
  },*/
];

// admin/ for admins & executors
export const EXECUTOR_ROUTES = [
  /*{
    path: ADMIN_PROJECTS_URL,
    element: <Projects />,
    sitemapIndex: true,
    exact: true,
  },*/
  {
    path: ADMIN_USERS_URL,
    element: <Users />,
    sitemapIndex: true,
    exact: true,
  },
  /*{
    path: ADMIN_PRODUCTS_URL,
    element: <ProductsManagement />,
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ADMIN_EDIT_PRODUCT_URL,
    element: <ProductEdit />,
    sitemapIndex: true,
    exact: true,
  },
  {
    path: ADMIN_PROMOTED_URL,
    element: <PromotedManagement />,
    sitemapIndex: true,
    exact: true,
  },*/
  {
    path: ADMIN_MANAGEMENT_SETTINGS_URL,
    element: <AdminSettings />,
    sitemapIndex: true,
    exact: true,
  },
  /*{
    path: ADMIN_ARCHIVE_PROJECTS_URL,
    element: <ArchiveProjects />,
    sitemapIndex: true,
    exact: true,
  },*/
];

// admin/ for users
export const USERS_ROUTES = [
  /*{
    path: ADMIN_USER_PROJECTS_URL,
    element: <ProjectsUser />,
    sitemapIndex: true,
    exact: true,
  },*/
];
